<template>
    <component :is="component" :item="item" />
</template>

<script>
import InterviewDetails from './InterviewDetails.vue'
import ReportDetails from './ReportDetails.vue'

export default {
    name: 'PremiumResearchDetails',
    components: {
        CeoChangeReport: ReportDetails,
        Interview: InterviewDetails,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        component() {
            return this.item.details?.entityType ?? 'CeoChangeReport'
        },
    },
}
</script>
